import type { WebsiteHeaderEventTitle } from '@shared/types/WebsiteHeaderSettings.types';

// The first family of each inline font-family declaration; tolerant of optional quotes and
// fallback stacks. Quote entities (&quot; — as the xss serializer emits inside style attributes)
// are decoded first: their embedded `;` would otherwise terminate the value match early.
// SSR-safe by construction (no DOM parsing). Matches anywhere in the string — a title whose TEXT
// literally contains "font-family: X" would request a junk family; harmless (failed stylesheet)
// and not worth a parser.
const QUOTE_ENTITY_PATTERN = /&quot;|&#34;|&#39;/g;
const FONT_FAMILY_PATTERN = /font-family:\s*["']?([^;"'<>]+)/gi;

export const extractFontFamiliesFromHtml = (html: string): ReadonlyArray<string> => {
  const families = new Set<string>();
  for (const match of html.replace(QUOTE_ENTITY_PATTERN, '"').matchAll(FONT_FAMILY_PATTERN)) {
    const family = match[1].split(',')[0].trim();
    if (family) {
      families.add(family);
    }
  }
  return [...families];
};

/**
 * The single typed reader of `eventName.contentHtml` inside an untyped header-presentation
 * dataJSON blob — keeps the field name compile-checked against WebsiteHeaderEventTitle instead
 * of restated structurally at use sites.
 */
export const getHeaderEventTitleHtml = (dataJSON: unknown): string | undefined => (dataJSON as { eventName?: WebsiteHeaderEventTitle } | null | undefined)?.eventName?.contentHtml;
